const DEP_TYPE = import.meta.env.DEPLOYMENT || "development";

// API Configuration
const apiBaseUrl =
  (DEP_TYPE === "production"
    ? import.meta.env.VITE_API_BASE_URL_PROD
    : DEP_TYPE === "development"
    ? import.meta.env.VITE_API_BASE_URL_DEV
    : import.meta.env.VITE_API_BASE_URL_LOCAL) || "";

// Application Configuration
const appName = import.meta.env.VITE_APP_NAME || "SnapShift Admin";
const appVersion = import.meta.env.VITE_APP_VERSION || "1.0.0";
const appDescription = import.meta.env.VITE_APP_DESCRIPTION || "SnapShift Admin Panel";

// Development Configuration
const devMode = import.meta.env.VITE_DEV_MODE === "true";
const enableLogging = import.meta.env.VITE_ENABLE_LOGGING === "true";
const enableDebug = import.meta.env.VITE_ENABLE_DEBUG === "true";

// Authentication Configuration
const jwtSecret = import.meta.env.VITE_JWT_SECRET;
const refreshTokenSecret = import.meta.env.VITE_REFRESH_TOKEN_SECRET;
const tokenExpiry = import.meta.env.VITE_TOKEN_EXPIRY || "24h";
const refreshTokenExpiry = import.meta.env.VITE_REFRESH_TOKEN_EXPIRY || "7d";

// CORS Configuration
const corsOrigin =
  (DEP_TYPE === "production"
    ? import.meta.env.VITE_CORS_ORIGIN_PROD
    : DEP_TYPE === "development"
    ? import.meta.env.VITE_CORS_ORIGIN_DEV
    : import.meta.env.VITE_CORS_ORIGIN_LOCAL) || "*";

// AWS Configuration
const awsRegion =
  (DEP_TYPE === "production"
    ? import.meta.env.VITE_AWS_REGION_PROD
    : DEP_TYPE === "development"
    ? import.meta.env.VITE_AWS_REGION_DEV
    : import.meta.env.VITE_AWS_REGION_LOCAL) || "us-east-1";

const bucketName =
  (DEP_TYPE === "production"
    ? import.meta.env.VITE_BUCKET_NAME_PROD
    : DEP_TYPE === "development"
    ? import.meta.env.VITE_BUCKET_NAME_DEV
    : import.meta.env.VITE_BUCKET_NAME_LOCAL) || "";

const bucketAccessKey =
  (DEP_TYPE === "production"
    ? import.meta.env.VITE_ACCESS_KEY_PROD
    : DEP_TYPE === "development"
    ? import.meta.env.VITE_ACCESS_KEY_DEV
    : import.meta.env.VITE_ACCESS_KEY_LOCAL) || "";

const bucketSecretKey =
  (DEP_TYPE === "production"
    ? import.meta.env.VITE_SECRET_KEY_PROD
    : DEP_TYPE === "development"
    ? import.meta.env.VITE_SECRET_KEY_DEV
    : import.meta.env.VITE_SECRET_KEY_LOCAL) || "";

const cdnUrl =
  (DEP_TYPE === "production"
    ? import.meta.env.VITE_AWS_CDN_PROD
    : DEP_TYPE === "development"
    ? import.meta.env.VITE_AWS_CDN_DEV
    : import.meta.env.VITE_AWS_CDN_LOCAL) || "";

// Email Configuration (Brevo)
const brevoApiKey =
  (DEP_TYPE === "production"
    ? import.meta.env.VITE_BREVO_API_KEY_PROD
    : DEP_TYPE === "development"
    ? import.meta.env.VITE_BREVO_API_KEY_DEV
    : import.meta.env.VITE_BREVO_API_KEY_LOCAL) || "";

const brevoSenderId =
  (DEP_TYPE === "production"
    ? import.meta.env.VITE_BREVO_SENDER_ID_PROD
    : DEP_TYPE === "development"
    ? import.meta.env.VITE_BREVO_SENDER_ID_DEV
    : import.meta.env.VITE_BREVO_SENDER_ID_LOCAL) || "";

// Google APIs Configuration
const googleApiKey =
  (DEP_TYPE === "production"
    ? import.meta.env.VITE_GOOGLE_API_KEY_PROD
    : DEP_TYPE === "development"
    ? import.meta.env.VITE_GOOGLE_API_KEY_DEV
    : import.meta.env.VITE_GOOGLE_API_KEY_LOCAL) || "";

// Stripe Configuration
const stripePublicKey =
  (DEP_TYPE === "production"
    ? import.meta.env.VITE_STRIP_PUBLIC_KEY_PROD
    : DEP_TYPE === "development"
    ? import.meta.env.VITE_STRIP_PUBLIC_KEY_DEV
    : import.meta.env.VITE_STRIP_PUBLIC_KEY_LOCAL) || "";

const stripeSecretKey =
  (DEP_TYPE === "production"
    ? import.meta.env.VITE_STRIP_SECRET_KEY_PROD
    : DEP_TYPE === "development"
    ? import.meta.env.VITE_STRIP_SECRET_KEY_DEV
    : import.meta.env.VITE_STRIP_SECRET_KEY_LOCAL) || "";

const stripeWebhookSecret =
  (DEP_TYPE === "production"
    ? import.meta.env.VITE_STRIPE_WEBHOOK_PROD
    : DEP_TYPE === "development"
    ? import.meta.env.VITE_STRIPE_WEBHOOK_DEV
    : import.meta.env.VITE_STRIPE_WEBHOOK_LOCAL) || "";

const stripeApiVersion =
  (DEP_TYPE === "production"
    ? import.meta.env.VITE_STRIPE_API_VERSION_PROD
    : DEP_TYPE === "development"
    ? import.meta.env.VITE_STRIPE_API_VERSION_DEV
    : import.meta.env.VITE_STRIPE_API_VERSION_LOCAL) || "2023-10-16";

// Redis Configuration
const redisHost =
  (DEP_TYPE === "production"
    ? import.meta.env.VITE_REDIS_HOST_PROD
    : DEP_TYPE === "development"
    ? import.meta.env.VITE_REDIS_HOST_DEV
    : import.meta.env.VITE_REDIS_HOST_LOCAL) || "localhost";

const redisPort =
  (DEP_TYPE === "production"
    ? import.meta.env.VITE_REDIS_PORT_PROD
    : DEP_TYPE === "development"
    ? import.meta.env.VITE_REDIS_PORT_DEV
    : import.meta.env.VITE_REDIS_PORT_LOCAL) || 6379;

const redisPassword =
  (DEP_TYPE === "production"
    ? import.meta.env.VITE_REDIS_PASSWORD_PROD
    : DEP_TYPE === "development"
    ? import.meta.env.VITE_REDIS_PASSWORD_DEV
    : import.meta.env.VITE_REDIS_PASSWORD_LOCAL) || "";

// Database Configuration
const databaseUrl =
  (DEP_TYPE === "production"
    ? import.meta.env.VITE_DATABASE_URL_PROD
    : DEP_TYPE === "development"
    ? import.meta.env.VITE_DATABASE_URL_DEV
    : import.meta.env.VITE_DATABASE_URL_LOCAL) || "";

// UI Configuration
const theme = import.meta.env.VITE_THEME || "light";
const language = import.meta.env.VITE_LANGUAGE || "en";
const timezone = import.meta.env.VITE_TIMEZONE || "UTC";

// Feature Flags
const enableAnalytics = import.meta.env.VITE_ENABLE_ANALYTICS === "true";
const enableNotifications = import.meta.env.VITE_ENABLE_NOTIFICATIONS === "true";
const enableRealTimeUpdates = import.meta.env.VITE_ENABLE_REAL_TIME_UPDATES === "true";

// Pagination Configuration
const itemsPerPage = parseInt(import.meta.env.VITE_ITEMS_PER_PAGE || "12");
const maxItemsPerPage = parseInt(import.meta.env.VITE_MAX_ITEMS_PER_PAGE || "100");

// Security Configuration
const enable2FA = import.meta.env.VITE_ENABLE_2FA === "true";
const sessionTimeout = parseInt(import.meta.env.VITE_SESSION_TIMEOUT || "30");
const maxLoginAttempts = parseInt(import.meta.env.VITE_MAX_LOGIN_ATTEMPTS || "5");
const lockoutDuration = parseInt(import.meta.env.VITE_LOCKOUT_DURATION || "15");

const adminConfig = {
  deployment: DEP_TYPE,

  // API Configuration
  api: {
    baseUrl: apiBaseUrl,
  },

  // Application Configuration
  app: {
    name: appName,
    version: appVersion,
    description: appDescription,
  },

  // Development Configuration
  dev: {
    mode: devMode,
    enableLogging,
    enableDebug,
  },

  // Authentication Configuration
  auth: {
    jwtSecret,
    refreshTokenSecret,
    tokenExpiry,
    refreshTokenExpiry,
  },

  // CORS Configuration
  cors: {
    origin: corsOrigin,
  },

  // AWS Configuration
  aws: {
    region: awsRegion,
    bucketName,
    accessKey: bucketAccessKey,
    secretKey: bucketSecretKey,
    cdnUrl,
  },

  // Email Configuration
  email: {
    brevo: {
      apiKey: brevoApiKey,
      senderId: brevoSenderId,
    },
  },

  // Google Configuration
  google: {
    apiKey: googleApiKey,
  },

  // Stripe Configuration
  stripe: {
    publicKey: stripePublicKey,
    secretKey: stripeSecretKey,
    webhookSecret: stripeWebhookSecret,
    apiVersion: stripeApiVersion,
  },

  // Redis Configuration
  redis: {
    host: redisHost,
    port: redisPort,
    password: redisPassword,
  },

  // Database Configuration
  database: {
    url: databaseUrl,
  },

  // UI Configuration
  ui: {
    theme,
    language,
    timezone,
  },

  // Feature Flags
  features: {
    analytics: enableAnalytics,
    notifications: enableNotifications,
    realTimeUpdates: enableRealTimeUpdates,
  },

  // Pagination Configuration
  pagination: {
    itemsPerPage,
    maxItemsPerPage,
  },

  // Security Configuration
  security: {
    enable2FA,
    sessionTimeout,
    maxLoginAttempts,
    lockoutDuration,
  },
};

export default adminConfig;
